import styled from "styled-components";

export const Wrapper = styled.div`
width: 100%;
height: 600px;
background: rgba(0,0,0,0.5);
backdrop-filter: blur(20px);
position: fixed;
margin: -300px 0;
`

export const ContentWrapper = styled.div`
  max-width: 900px;
  height: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  z-index: 1;
`;

export const ImageCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  height: 80%;

  & img {
    max-width: 100%;
    height: 100%;
  }
`;


export const CloseIcon = styled.div`
color: white;
font-size: 34px;
cursor: pointer;
border: 1px solid white;
padding: 10px 10px;
display: flex;
align-items: center;
`